<template>
  <div class="content-width--sm">

    <div style="max-width: 360px; margin: auto; text-align: center;">
      <h1 style="line-height: 1.25em;">Thank you for submitting your film license</h1>
    </div>

    <p>
      {{isDraft ? 'The draft for each episode have been created.' : 'Your series and episodes have been submitted to our team for review.'}}
    </p>
    <p>
      {{isDraft 
      ? 'You can find them under the Incomplete section in your Dashboard. Once ready, you may complete the submission process by clicking "submit" for each episode.' 
      : 'You should be able to find them on your Dashboard in the Under Review section. You should receive a notification on the result of the review process within 2 weeks.'
      }}
    </p>
    <el-button
      type="primary"
      @click="$router.push(`/`)"
      class="return-button"
    >
      Return to dashboard
    </el-button>
  </div>
</template>

<script>
import logo from '@/assets/logo.png';

export default {
  props: {
    isDraft: Boolean,
  },
  data() {
    return {
      logo,
    };
  },
};
</script>

<style lang="scss">

.return-button {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

</style>


// WEBPACK FOOTER //
// src/components/Licenses/Others/SeriesThankYou.vue